import { useContext } from 'react'
import { AuthenticationContext } from '../contexts'

export function useAuthentication () {
  return useContext(AuthenticationContext)
}
